<template>
  <div>
    <div @click="handleClick" class="camera" v-if="this.realtimeData.state === true && mode === 'view'" :style="style">
      <input type="button" class="btn" value="上" onmousedown="PTZControl(0,0);"
             onmouseup="PTZControl(0,1);" />
      <input type="button" class="btn" value="下" onmousedown="PTZControl(1,0);"
             onmouseup="PTZControl(1,1);" />
      <input type="button" class="btn" value="左" onmousedown="PTZControl(2,0);"
             onmouseup="PTZControl(2,1);" />
      <input type="button" class="btn" value="右" onmousedown="PTZControl(3,0);"
             onmouseup="PTZControl(3,1);" />
      <video :id="name+id" :style="styleVideo" controls autoplay></video>
    </div>
    <div class="camera" v-else :style="style">
      <div :style="styleButton">
        <button  @mousedown="PTZControl(0,0);" @mouseup="PTZControl(0,1);">上</button>
        <button  @mousedown="PTZControl(1,0);" @mouseup="PTZControl(1,1);">下</button>
        <button  @mousedown="PTZControl(2,0);" @mouseup="PTZControl(2,1);">左</button>
        <button  @mousedown="PTZControl(3,0);" @mouseup="PTZControl(3,1);">右</button>
        <button @click="timePickVisible = true">历史视频</button>
      </div>
        <video :id="name+id" :style="styleVideo" controls autoplay></video>
    </div>a

    <el-dialog
        title="选择时间"
        :visible.sync="timePickVisible"
        width="30%"
    >
      <el-date-picker
          v-model="startTime"
          type="datetime"
          format="yyyy-MM-ddTHH:mm"
          value-format="yyyy-MM-ddTHH:mm"
          placeholder="回放起始时间">
      </el-date-picker>
      -
      <el-date-picker
          v-model="endTime"
          type="datetime"

          format="yyyy-MM-ddTHH:mm"
          value-format="yyyy-MM-ddTHH:mm"
          placeholder="回放截至时间">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="timePickVisible = false">取 消</el-button>
        <el-button type="primary" @click=comfirmHistory>确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="下载视频"
        :visible.sync="downLoadVisible"
        width="30%"
    >
      <el-table
          :data="listInfo"
          style="width: 100%">
        <el-table-column
            prop="filename"
            label="文件名"
            width="180">
        </el-table-column>
        <el-table-column
            prop="starttime"
            label="起始时间"
            width="180">
        </el-table-column>
        <el-table-column
            prop="endtime"
            label="终止时间"
            width="180">
        </el-table-column>
        <el-table-column label="下载" width="180">
          <template slot-scope="scope">
            <el-button @click="download(scope.row)" type="text" size="small">下载</el-button>
<!--            <el-button type="text" size="small">编辑</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>


  </div>
</template>


<script>

import componentsMixin from "../componentsMixin";
import API from "../../../../../config/api";
import v from "../camera/jmuxer"
import DOMAIN_PREFIX from "../../../../../config/domainPrefix";

export default {
  name: "cameraComponent",
  mixins: [componentsMixin],
  data() {
    return {
      state: true,
      camera: "",
      ws: "",
      timePickVisible: false,
      downLoadVisible: false,
      startTime: "",
      endTime: "",
      listInfo: [],
    }
  },
  mounted() {
    // let script = document.createElement('script');
    // script.type = 'text/javascript';
    // script.src = '../camera/jmuxer.js';
    // script.text = ''
    // document.body.appendChild(script);
    //this.init();
    console.log("组件的名称为",this.name+this.id)
  },
  destroyed() {
    console.log("摄像头要被销毁了")
    if (this.ws !== "") {
      this.ws.close()
    }

    //this.ws.close()
    // this.ws.onClose(1)
    // this.ws.terminate()

  },
  computed: {
    styleVideo() {
      let res = {...this.style};
      //res.top = "10%"
      res.width = "100%";
      res.height = "90%";
      res.position = "relative";
      return res;
    },
    styleButton() {
      let res = {...this.style};
      res["width"] = "100%";
      res["height"] = "10%";
      res["position"] = "relative";
      res["verticalAlign"] = "middle";
      return res;
    }
  },
  methods: {

    async getCamera() {
      // 向后端注册
      let res = await this.$axiosRequest({
        url: API.startShow,
        method: 'GET',
        data: {
          Camera: this.camera
        },
        header: API.header,
      });
      //this.camera = "K27207072";
      //
      var cmdFN = function (cmd) {
        if (cmd.action == 'init') {
          var message = 'REQUESTSTREAM ';
          this.ws.send(message);
        } else if (cmd.msg == 'size') {
          console.log('初始化成功: size: ' + cmd.width + ',' + cmd.height);
          window.isInit = true;
        } else if (cmd.size == 'msg') {
          console.log('初始化成功: size: ' + cmd.width + ',' + cmd.height);
          window.isInit = true;
        }
      }
      var socketURL = DOMAIN_PREFIX.CAMERA_DEPLOYED_PATH + this.camera + "&token";  // 请求的链接
      //var socketURL = 'ws://'+ip+':8081/realplay/' + this.camera + "&token";
      var jmuxer = new JMuxer({    // 创建一个处理视频的对象，引入的依赖
        node: this.name+this.id,
        mode: 'video',
        flushingTime: 100,
        fps: 15,
        debug: false
      });
      this.ws = new WebSocket(socketURL);   // 新建连接，连接建立后后端就会一直发送视频流
      //console.log("this.ws",this.ws,wsTest,this.ws===wsTest)
      //console.log("this.ws",this.ws)
      let ws = this.ws
      ws.binaryType = 'arraybuffer';
      ws.onmessage = function (event) {   // 监听后端发送的消息
        console.log("接收到后端信息")
        if (typeof event.data == 'string') {
          return cmdFN(JSON.parse(event.data));
        }
        else {
          jmuxer.feed({
            video: new Uint8Array(event.data),    // 展示视频
          });
        }
      };

      // ws.addEventListener('message', function (event) {   // 监听后端发送的消息
      //   if (typeof event.data == 'string') {
      //     return cmdFN(JSON.parse(event.data));
      //   }
      //   else {
      //     jmuxer.feed({
      //       video: new Uint8Array(event.data),    // 展示视频
      //     });
      //   }
      // });
      // ws.addEventListener('error', function () {
      //   console.log('Socket Error');
      // });
      ws.onclose = function (e) {
        console.log("关闭连接")
      }
    },
    PTZControl(dir, action) {
      this.$axiosRequest({
        url: API.remoteControl,
        method: 'GET',
        data: {
          Camera: this.camera,
          dir: dir,
          action: action
        },
        header: API.header,
        success: res => {
          console.log("访问成功",res)
        }
      });
    },
    async comfirmHistory() {
      await this.$axiosRequest({    // 请求后端获取列表数据
        url: API.findAllFile,
        method: 'GET',
        data: {
          Camera: this.camera,
          startTime: this.startTime,
          endTime: this.endTime
        },
        header: API.header,
        success: res => {
          console.log("访问成功",res)
          this.listInfo = res.data["allfile"]
        }
      });
      this.timePickVisible = false   // 时间选择关闭
      console.log("this.listInfo",this.listInfo)
      this.downLoadVisible = true     // 展示下载页面
    },
    download(row) {    // 下载文件
      console.log("点击下载文件",row.filename)
      // this.$axiosRequest({    // 请求后端获取列表数据
      //     url: API.download,
      //     method: 'GET',
      //     data: {
      //       Camera: this.camera,
      //       fileName: row.filename,
      //     },
      //     header: API.header,
      // });
      // var xhr = new XMLHttpRequest();
      // var url = API.downloadTest + this.userSuffix + '&filename=' + encodeURIComponent(row.filename) + '&camera=' + encodeURIComponent(this.camera);
      // console.log(url)
      // xhr.open('GET', url, true);
      // xhr.responseType = 'blob';
      // xhr.onload = function () {
      //   if (xhr.status == 200) {
      //     var context = xhr.response;
      //     var blob = new Blob([xhr.response], {type: 'application/octet-stream'});
      //     if (blob.size == 0) {
      //       alert("请稍等一分钟，服务器正在缓存数据");
      //     } else {
      //       console.log(blob)
      //       saveAs(blob, 'file.mp4');
      //     }
      //   }
      // }
      // xhr.send();
      let downloadUrl = API.download + this.userSuffix + '&filename=' + encodeURIComponent(row.filename) + '&camera=' + encodeURIComponent(this.camera);

      this.$axios({
        url: downloadUrl,
        method: 'get',
        responseType: 'arraybuffer'
      }).then(res => {
        console.log("结果为",res)
        const blob = new Blob([res.data]);
        if (blob.size == 0) {
          alert("请稍等一分钟，服务器正在缓存数据")
        }else {
          //创建一个<a></a>标签
          let a = document.createElement("a");
          // 将流文件写入a标签的href属性值
          a.href = URL.createObjectURL(blob);
          //设置文件名
          a.download = "template.mp4";
          // 隐藏a标签
          a.style.display = "none";
          // 将a标签追加到文档对象中
          document.body.appendChild(a);
          // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
          a.click();
          //用完就删除a标签
          a.remove();
        }
      })
    }
  },
  watch: {
    'realtimeData.sn': {
      immediate:true,
      handler(val) {
        this.camera = val
        if (this.camera !== "") {
          this.getCamera()
        }
      }
    }
  }
}
</script>

<style scoped>
.camera {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
</style>